import { Clock, Calendar } from 'lucide-react';

import {
  getDateWithTimeZone,
  getTimeWithTimeZone
} from '@/helpers/dateHelpers';

const BookingTitleAndTime = ({ booking }) => {
  return (
    <div className="py-4 px-4">
      <h1 className="text-2xl font-bold mb-4">{booking.offeringName}</h1>
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Calendar className="w-6 h-6 text-muted-foreground" />
          <span className="text-md">
            {getDateWithTimeZone(
              booking.startDateTime,
              booking.timeZone,
              'EEEE MMM d, yyyy'
            )}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="w-6 h-6 text-muted-foreground" />
          <span className="text-md">
            {getTimeWithTimeZone(booking.startDateTime, booking.timeZone)} -{' '}
            {getTimeWithTimeZone(booking.endDateTime, booking.timeZone)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BookingTitleAndTime;
